(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-style-patch"]) return;
  try {
    
  function tmPickupAddressLine(el) {
    const textEl = el.querySelector('.pickup-location__text-sm');
    const btn = el.querySelector('.pickup-location__button');
    if (!textEl || !btn || el.querySelector('.tm-pickup-address')) return;

    const match = (btn.getAttribute('on:click') || '').match(/#([\w-]+)/);
    const drawer = match && document.getElementById(match[1]);
    const addressParagraph = drawer && drawer.querySelector('.pickup-location__address p');
    if (!addressParagraph) return;

    const lines = addressParagraph.innerHTML
      .split('<br>')
      .map((line) => line.replace(/<[^>]+>/g, '').trim());
    const summary = [lines[1], lines[2]].filter(Boolean).join(', ');
    if (!summary) return;

    const line = document.createElement('p');
    line.className = 'pickup-location__text-xs tm-pickup-address';
    line.textContent = summary;
    textEl.insertAdjacentElement('afterend', line);
  }

  function tmInitPickupAddresses() {
    document.querySelectorAll('.product__pickup-availabilities').forEach((el) => {
      tmPickupAddressLine(el);
      new MutationObserver(() => tmPickupAddressLine(el)).observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tmInitPickupAddresses);
  } else {
    tmInitPickupAddresses();
  }

  function tmApplyTrustBarFont() {
    const iframe = document.getElementById('trust-bar');
    if (!iframe) return false;

    let doc;
    try {
      doc = iframe.contentDocument;
    } catch (e) {
      return false;
    }
    if (!doc || !doc.body) return false;

    const headingFont = getComputedStyle(document.documentElement)
      .getPropertyValue('--font-heading--family')
      .trim();
    if (!headingFont) return false;

    const apply = () => {
      const title = doc.querySelector('.trustBarTitle');
      if (title) {
        title.style.fontFamily = headingFont;
        title.style.fontWeight = '700';
      }
    };

    apply();
    new MutationObserver(apply).observe(doc.body, { childList: true, subtree: true });
    return true;
  }

  let tmTrustBarTries = 0;
  const tmTrustBarInterval = setInterval(() => {
    tmTrustBarTries += 1;
    if (tmApplyTrustBarFont() || tmTrustBarTries > 40) {
      clearInterval(tmTrustBarInterval);
    }
  }, 250);

  } catch(e) { console.error(e); }
})();
})();
